import mergeWith from 'lodash/mergeWith';
import {
  UPDATE_PRODUCTS_PAGE,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_UPDATE_SUCCESS,
} from '../actions/products';
import { FETCH_BUNDLES_SUCCESS, FETCH_BUNDLES_UPDATE_SUCCESS } from '../actions/bundles';
import { FETCH_CONTRACTS_SUCCESS, FETCH_CONTRACTS_UPDATE_SUCCESS } from '../actions/contracts';
import { FETCH_PARTNERS_SUCCESS } from '../actions/partners';
import { FETCH_USERS_SUCCESS } from '../actions/users';
import { FETCH_STATEMENTS_SUCCESS } from '../actions/statements';
import {
  FETCH_DIMENSIONLISTS_SUCCESS,
  FETCH_DIMENSIONLISTS_UPDATE_SUCCESS,
} from '../actions/dimensionList';
import { FETCH_ADJUSTMENTS_SUCCESS } from '../actions/adjustments';
import { FETCH_ADVANCEGROUPS_SUCCESS } from '../actions/advanceGroups';
import {
  UPDATE_AGREEMENT_PRODUCTS_PAGE,
  FETCH_AGREEMENT_PRODUCTS_SUCCESS,
} from '../actions/agreements';
import {
  FETCH_TRANSACTIONCOUNT_SUCCESS,
  FETCH_TRANSACTIONS_SUCCESS,
  SORT_TRANSACTIONS,
} from '../actions/transactions';
import mergeOverwriteArrays, { mergeArrays } from '../utils';

const initialState = {
  adjustments: {
    page: 1,
    totalCount: 0,
    results: [],
  },
  products: {
    page: 1,
    totalCount: 0,
    results: [],
  },
  bundles: {
    page: 1,
    totalCount: 0,
    results: [],
  },
  agreementProducts: {
    page: 1,
    totalCount: 0,
    results: [],
  },
  transactions: {
    page: 1,
    results: [],
    order: 'desc',
  },
};

// eslint-disable-next-line default-param-last
function paginationReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_PRODUCTS_PAGE:
      return mergeWith({}, state, { products: { page: action.payload } }, mergeOverwriteArrays);

    case UPDATE_AGREEMENT_PRODUCTS_PAGE:
      return mergeWith(
        {},
        state,
        { agreementProducts: { page: action.payload } },
        mergeOverwriteArrays,
      );

    case FETCH_ADJUSTMENTS_SUCCESS:
      if (!action.payload.result) {
        return state;
      }

      return mergeWith(
        {},
        state,
        {
          adjustments: { results: action.payload.result, totalCount: action.meta.totalCount },
        },
        mergeOverwriteArrays,
      );

    case FETCH_ADVANCEGROUPS_SUCCESS:
      if (!action.payload.result) {
        return state;
      }

      return mergeWith(
        {},
        state,
        {
          advancegroups: { results: action.payload.result, totalCount: action.meta.totalCount },
        },
        mergeOverwriteArrays,
      );

    case FETCH_PRODUCTS_SUCCESS:
      if (!action.payload.result) {
        return state;
      }

      return mergeWith(
        {},
        state,
        {
          products: { results: action.payload.result, totalCount: action.meta.totalCount },
        },
        mergeOverwriteArrays,
      );

    case FETCH_PRODUCTS_UPDATE_SUCCESS:
      if (!action.payload.result) {
        return state;
      }

      return mergeWith(
        {},
        state,
        {
          products: { results: action.payload.result, totalCount: action.meta.totalCount },
        },
        mergeArrays,
      );

    case FETCH_BUNDLES_SUCCESS:
      if (!action.payload.result) {
        return state;
      }

      return mergeWith(
        {},
        state,
        {
          bundles: { results: action.payload.result, totalCount: action.meta.totalCount },
        },
        mergeOverwriteArrays,
      );

    case FETCH_BUNDLES_UPDATE_SUCCESS:
      if (!action.payload.result) {
        return state;
      }

      return mergeWith(
        {},
        state,
        {
          bundles: { results: action.payload.result, totalCount: action.meta.totalCount },
        },
        mergeArrays,
      );

    case FETCH_CONTRACTS_SUCCESS:
      if (!action.payload.result) {
        return state;
      }

      return mergeWith(
        {},
        state,
        {
          contracts: { results: action.payload.result, totalCount: action.meta.totalCount },
        },
        mergeOverwriteArrays,
      );

    case FETCH_CONTRACTS_UPDATE_SUCCESS:
      if (!action.payload.result) {
        return state;
      }
      return mergeWith(
        {},
        state,
        {
          contracts: { results: action.payload.result, totalCount: action.meta.totalCount },
        },
        mergeArrays,
      );

    case FETCH_PARTNERS_SUCCESS:
      if (!action.payload.result) {
        return state;
      }

      return mergeWith(
        {},
        state,
        {
          partners: { results: action.payload.result, totalCount: action.meta.totalCount },
        },
        mergeOverwriteArrays,
      );

    case FETCH_STATEMENTS_SUCCESS:
      if (!action.payload.result) {
        return state;
      }

      return mergeWith(
        {},
        state,
        {
          statements: { results: action.payload.result, totalCount: action.meta.totalCount },
        },
        mergeOverwriteArrays,
      );

    case FETCH_DIMENSIONLISTS_SUCCESS:
      if (!action.payload.result) {
        return state;
      }
      return mergeWith(
        {},
        state,
        {
          dimensionLists: { results: action.payload.result, totalCount: action.meta.totalCount },
        },
        mergeOverwriteArrays,
      );

    case FETCH_DIMENSIONLISTS_UPDATE_SUCCESS:
      if (!action.payload.result) {
        return state;
      }
      return mergeWith(
        {},
        state,
        {
          dimensionLists: { results: action.payload.result, totalCount: action.meta.totalCount },
        },
        mergeArrays,
      );

    case FETCH_AGREEMENT_PRODUCTS_SUCCESS:
      if (!action.payload.result) {
        return state;
      }

      return mergeWith(
        {},
        state,
        {
          agreementProducts: { results: action.payload.result, totalCount: action.meta.totalCount },
        },
        mergeOverwriteArrays,
      );

    case FETCH_USERS_SUCCESS:
      if (!action.payload.result) {
        return state;
      }
      return mergeWith({}, state, {
        users: { results: action.payload.result, totalCount: action.meta.totalCount },
      });
    case FETCH_TRANSACTIONCOUNT_SUCCESS:
      return mergeWith({}, state, { transactionsStats: action.payload });

    case SORT_TRANSACTIONS:
      return mergeWith({}, state, { transactions: { page: action.payload } }, mergeOverwriteArrays);

    case FETCH_TRANSACTIONS_SUCCESS:
      if (!action.payload.result) {
        return state;
      }

      return mergeWith(
        {},
        state,
        {
          transactions: { results: action.payload.result },
        },
        mergeOverwriteArrays,
      );

    default:
      return state;
  }
}

export default paginationReducer;
